import { Injectable } from '@angular/core';
import * as math from 'mathjs';
import { BehaviorSubject, Observable, map, of } from 'rxjs';
import { ProductRepository } from '../repositories/products.repository';

@Injectable({
  providedIn: 'root',
})
export class UnitConversionService {
  constructor(private productRepository: ProductRepository) {}

  private selectedMaxFlowUnitSubject = new BehaviorSubject<string>('m³/h');
  selectedMaxFlowUnit$ = this.selectedMaxFlowUnitSubject.asObservable();

  setSelectedUnit(unit: string) {
    this.selectedMaxFlowUnitSubject.next(unit);
  }

  fetchFormula(valueType: string, sourceUnit: string, targetUnit: string): Observable<string> {
    return this.productRepository.fetchFormula(valueType, sourceUnit, targetUnit);
  }

  convert(value: number | null, fromUnit: string, toUnit: string, valueType: string): Observable<number | null> {
    // Handle null or undefined values
    if (value === null || value === undefined) {
      return of(null);
    }

    if (fromUnit === toUnit) {
      return of(value);
    }
    return this.fetchFormula(valueType, fromUnit, toUnit).pipe(
      map((formula) => {
        // Using mathjs.evaluate() for safe mathematical expression evaluation
        const result = math.evaluate(formula, { x: value });
        if (result === undefined) {
          throw new Error(`math.evaluate(${formula}, { x: ${value} }) returned undefined`);
        }
        if (Math.abs(result - Math.round(result)) < 0.00001) {
          return Math.round(result);
        }

        // Otherwise, round to two decimal places
        return parseFloat(result.toFixed(2));
      }),
    );
  }
  convertMinMax(value: number, fromUnit: string, toUnit: string, valueType: string): Observable<number> {
    return this.convert(value, fromUnit, toUnit, valueType);
  }
}
